import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Construction } from 'lucide-react'
import { Button, Card, EmptyState, Page } from '@/components/ui'
import '@/components/acdmc/acdmc.css'

type Props = {
  title: string
  subtitle: string
  phase: number
  body: string
  primaryHref?: string
  primaryLabel?: string
}

const AcdmcSectionPlaceholder: React.FC<Props> = ({
  title,
  subtitle,
  phase,
  body,
  primaryHref,
  primaryLabel,
}) => {
  const navigate = useNavigate()
  return (
    <Page>
      <Card>
        <EmptyState
          icon={Construction}
          title={title}
          body={
            <>
              <p>{body}</p>
              <p className="cb-muted ac-note">Planned for Phase {phase} of the ACDMC rollout.</p>
            </>
          }
          action={
            primaryHref ? (
              <Button onClick={() => navigate(primaryHref)}>{primaryLabel || 'Go to related area'}</Button>
            ) : (
              <Button variant="tertiary" onClick={() => navigate('/acdmc/dashboard')}>
                Back to dashboard
              </Button>
            )
          }
        />
        <p className="cb-muted ac-note">{subtitle}</p>
      </Card>
    </Page>
  )
}

export default AcdmcSectionPlaceholder
